<template>
    <div class="pop_up_layer com_pop" style="display: block" @click="closeModal"></div>
    <div class="pop_up flex_box com_pop" style="display: block">
        <div class="pop_tit _flex">
            <p>1:1 문의 답변</p>
            <button class="close_btn icon_wrap" @click="closeModal">
                <img src="img/close.png" alt="닫기" />
            </button>
        </div>
        <div class="result_form">
            <ul>
                <li>
                    <span class="form_li_tit">작성자</span>
                    <span>{{ props.data.userName }}</span>
                </li>
                <li>
                    <span class="form_li_tit">작성일</span>
                    <span>{{ CommonUtils.dateFormat(new Date(props.data.createDate), ".", true) }}</span>
                </li>
                <li>
                    <span class="form_li_tit">제목</span>
                    <span>{{ props.data.title }}</span>
                </li>
                <li class="li_con">
                    <label for="qna_q" class="form_li_tit">내용</label>
                    <textarea name="" id="qna_q" class="custom_scroll h_200" disabled v-text="props.data.content"></textarea>
                </li>
                <hr />
                <li class="li_con">
                    <label for="qna_a" class="form_li_tit">답변</label>
                    <textarea name="" id="qna_a" class="custom_scroll" v-model="props.data.comment"></textarea>
                </li>
            </ul>
            <div class="_flex _center btn_wrap">
                <button class="submit_btn _130 _gray" style="margin-top: 10px" @click="closeModal">취소</button>
                <button v-if="!props.isEdit" class="submit_btn _130 _main_blue" style="margin-top: 10px" @click="save(false)">답변 등록</button>
                <button v-else class="submit_btn _130 _main_blue" style="margin-top: 10px" @click="save(true)">답변 수정</button>
            </div>
        </div>
    </div>
</template>
<script lang="ts">
    import { onMounted, reactive, watch, onUnmounted, CommonUtils, apiService, types, getMessageByCode } from "@/BaseComponent";

    export default {
        props: {
            data: {
                type: Object,
                defalut: {},
            },
            isEdit: { type: Boolean, default: false },
        },
        emits: ["close", "save"],
        setup(props: any, { emit }: any) {
            const state = reactive({
                idx: 0 as number,
                data: {} as any,

                isShowModal: false as boolean,
                modalTab: -1 as number,
            });

            onMounted(() => {});

            onUnmounted(() => {});

            const closeModal = () => emit("close");

            const save = (isEdit: boolean) => {
                const param: types.ReqComment = {
                    idx: props.data.idx,
                    answer: props.data.comment,
                };

                emit("save", isEdit, param);
            };

            return { state, closeModal, props, CommonUtils, save };
        },
    };
</script>
